import React, { useCallback } from "react";
import InfiniteScroll from "react-infinite-scroller";
import "./styles.less";

import ReactLoading from "react-loading";
import { useTranslation } from "react-i18next";
import Axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export const ApplicationCard = (props) => {
  const { name, descript, icon, type } = props;
  const { t } = useTranslation();
  const nav = useNavigate();
  return (
    <Link className="application-card" to={`/apn/detail/${type}`}>
      <div className="icon-name-warp">
        <div className="icon">
          <img src={icon} alt="authing" />
        </div>
        <div className="name">{name}</div>
      </div>
      <div className="descript">{descript}</div>
      <div
        className="button"
        onClick={() => {
          nav(`/apn/detail/${type}`);
        }}
      >
        {t("marketplace.recommend.get")}
      </div>
    </Link>
  );
};

export const MarketplaceListScroll = (props) => {
  const { t, i18n } = useTranslation();
  const {
    list,
    setList,
    currentType,
    currentTotal,
    loading,
    setLoading,
    searchLock,
  } = props;
  const size = 45;
  const handleFetch = useCallback((params) => {
    let page = Math.floor(params / size);
    if (params - size >= currentTotal || searchLock) return;
    setLoading(true);
    Axios.get(
      `/api/marketplace-list?page=${page}&category=${currentType}&query=`
    )
      .then((res) => {
        const dataList = res?.data?.data || [];
        setList(list?.concat(dataList));
        setLoading(false);
      })
      .catch((res) => {
        console.log("error" + res);
        setLoading(false);
      });
  });

  return (
    <div className="application-box">
      <div
        className="scroll-pane"
        onMouseEnter={() => {
          document.body.style.overflowY = "hidden";
        }}
        onMouseLeave={() => {
          document.body.style.overflowY = "unset";
        }}
      >
        <InfiniteScroll
          pageStart={0}
          loadMore={() => handleFetch(list?.length + size)}
          hasMore={true || false}
          useWindow={false}
          loader={
            loading && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignContent: "center",
                  paddingTop: "40px",
                }}
              >
                <ReactLoading
                  type="spinningBubbles"
                  color="#215ae5"
                  height={60}
                  width={60}
                />
              </div>
            )
          }
        >
          <div className="application-warp">
            {list?.length > 0
              ? list?.map((item, index) => {
                  return (
                    <ApplicationCard
                      name={item.nameI18n[i18n.language] || item.name}
                      descript={item.descriptionI18n[i18n.language]}
                      key={index}
                      icon={item.logo}
                      type={item.identifier}
                    />
                  );
                })
              : !loading && (
                  <div className="marketplace-null">
                    <img
                      src="//files.authing.co/authing-website/marketplace-null.png"
                      alt="authing"
                    />
                    <div className="marketplace-null-text">
                      {t("marketplace.other.app-null")}
                    </div>
                  </div>
                )}
          </div>
        </InfiniteScroll>
      </div>
    </div>
  );
};
